$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop() + 220;
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

// $(window).on('resize scroll', function() {
//     $('.c-collection-tab__item').removeClass('is-active');
//     if ($('#limited-edition-collections').isInViewport()) {
//         $('.c-collection-tab__item[data-id="limited-edition-collections"]').addClass('is-active');
//     } else if ($('#collector-items').isInViewport()) {
//         $('.c-collection-tab__item[data-id="collector-items"]').addClass('is-active');
//     } else if ($('#personalised-giftbox').isInViewport()) {
//         $('.c-collection-tab__item[data-id="personalised-giftbox"]').addClass('is-active');
//     } else if ($('#holiday-editions').isInViewport()) {
//         $('.c-collection-tab__item[data-id="holiday-editions"]').addClass('is-active');
//     } else if ($('#Moet-celebration-coll').isInViewport()) {
//         $('.c-collection-tab__item[data-id="Moet-celebration-coll"]').addClass('is-active');
//     } else if ($('#Limited-Editions').isInViewport()) {
//         $('.c-collection-tab__item[data-id="Limited-Editions"]').addClass('is-active');
//     } else if ($('#clicquot-icons').isInViewport()){
//         $('.c-collection-tab__item[data-id="clicquot-icons"]').addClass('is-active');
//     }
    
// });

$( document ).ready(function() {
    $('.c-exp-tabs__item-btn').click(function() {
        $('.c-exp-tabs__item').removeClass('is-active');

        $(this).closest('.c-exp-tabs__item').addClass('is-active');

        var $dataTab = $(this).data('tab');
        var $sectionTabTop = $('#' + $dataTab).offset().top;
        let $targetTop;

        if ($(window).scrollTop() <= $sectionTabTop) {
            $targetTop = $sectionTabTop 
                - $('.c-collection-tab').height() 
                - $('#shopify-section-announcement-bar').height();
        } else {
            $targetTop = $sectionTabTop 
                - $('.c-collection-tab').height() 
                - $('.header-wrapper').height() 
                - $('#shopify-section-announcement-bar').height();
        }

        $('html, body').animate({
            scrollTop: $targetTop
        }, 500);
    });

    $('.shopify-section--featured-collection').each(function(){
        $thisSectionBottom = $(this).offset().top + $(this).outerHeight();
    })

    function setTopDock(){

        setTimeout(function(){
            var $announcementHeight = $('#shopify-section-announcement-bar').height();
            var $stickyHeaderHeight = $('#sticky-header-wrapper').height();
            if($('.shopify-section-header-hidden').length){
                $('.shopify-section--tabs').css('top', $announcementHeight);
            }else{
                $tabs = $announcementHeight + $stickyHeaderHeight + 'px';
                $('.shopify-section--tabs').css('top', $tabs);
            }
        },300)

        $(window).scroll(function(){
            var $announcementHeight = $('#shopify-section-announcement-bar').height();
            var $stickyHeaderHeight = $('#sticky-header-wrapper').height();
            if($('.shopify-section-header-hidden').length){
                $('.shopify-section--tabs').css('top', $announcementHeight);
            }else{
                $tabs = $announcementHeight + $stickyHeaderHeight + 'px';
                $('.shopify-section--tabs').css('top', $tabs);
            }


        })
    }
    setTopDock();

    $(window).resize(function(){
        setTopDock();
    })

});
